export const REQUEST_USER = 'REQUEST_USER'
export const CONFIRM_USER = 'CONFIRM_USER'
